module.exports = __webpack_public_path__ + "img/qualification-active.cc65a466.svg";